class SiteNav {

    constructor(passedElement) {
        let self = this;

        // Set elements
        self.elem = passedElement;
        self.items = [...self.elem.querySelectorAll('li')]; // It better damned be semantically marked up! 

        // Set the timeout initial val & increment val
        self.initial = 500;
        self.increment = 100;
    }

    init() {
        let self = this;

        self.items.map((item, index) => {

            item.style.transitionDelay = `${ (self.initial + (self.increment * index)) }ms`;
        });
    }
}

export default SiteNav;